<mat-selection-list fxFlex="100" [formControl]="insuranceCompaniesControl">
  <div fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="row">
      <h2>Wybór załączników do umowy {{contractObject.number}} do wygenerowania</h2>
    </div>

    <div fxLayout="row">
      <h3>Majątek</h3>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutGap.lt-md="0">
      <ng-container *ngFor="let column of assetsInsuranceCompanies">
        <div fxLayout="column" fxFlex="33" fxFlex.lt-md="100" >
          <ng-container *ngFor="let insuranceCompany of column">
            <div fxLayout="column">
              <mat-list-option checkboxPosition="before"
                               [value]="insuranceCompany.id"
                               [class.disabled-list-element]="currentInsuranceCompanyIds.includes(insuranceCompany.id)"
              >
                <div>
                  <img *ngIf="insuranceCompany.imageLocation" class="insurance-company-logo"
                       src="/rest/crm/insuranceCompany/{{insuranceCompany.id}}/image" alt="Zdjęcie" height="30"/>
                  <span [class.insurance-company-name]="insuranceCompany.imageLocation">{{insuranceCompany.name}}</span>
                </div>
              </mat-list-option>

              <ng-container *ngFor="let childInsuranceCompany of insuranceCompany.children">
                <mat-list-option checkboxPosition="before"
                                 class="child-company"
                                 *ngIf="!childInsuranceCompany.inactive"
                                 [value]="childInsuranceCompany.id"
                                 [class.disabled-list-element]="currentInsuranceCompanyIds.includes(childInsuranceCompany.id)"
                >
                  <div>
                    <img *ngIf="childInsuranceCompany.imageLocation" class="insurance-company-logo"
                         src="/rest/crm/insuranceCompany/{{childInsuranceCompany.id}}/image" alt="Zdjęcie" height="30"/>
                    <span [class.insurance-company-name]="childInsuranceCompany.imageLocation">{{childInsuranceCompany.name}}</span>
                  </div>
                </mat-list-option>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div fxLayout="row">
      <h3>Życie</h3>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutGap.lt-md="0">
      <ng-container *ngFor="let column of lifeInsuranceCompanies">
        <div fxLayout="column" fxFlex="33" fxFlex.lt-md="100" >
          <ng-container *ngFor="let insuranceCompany of column">
            <div fxLayout="column">
              <mat-list-option checkboxPosition="before"
                               [value]="insuranceCompany.id"
                               [class.disabled-list-element]="currentInsuranceCompanyIds.includes(insuranceCompany.id)"
              >
                <div>
                  <img *ngIf="insuranceCompany.imageLocation" class="insurance-company-logo"
                       src="/rest/crm/insuranceCompany/{{insuranceCompany.id}}/image" alt="Zdjęcie" height="30"/>
                  <span [class.insurance-company-name]="insuranceCompany.imageLocation">{{insuranceCompany.name}}</span>
                </div>
              </mat-list-option>

              <ng-container *ngFor="let childInsuranceCompany of insuranceCompany.children">
                <mat-list-option checkboxPosition="before"
                                 class="child-company"
                                 *ngIf="!childInsuranceCompany.inactive"
                                 [value]="childInsuranceCompany.id"
                                 [class.disabled-list-element]="currentInsuranceCompanyIds.includes(childInsuranceCompany.id)"
                >
                  <div>
                    <img *ngIf="childInsuranceCompany.imageLocation" class="insurance-company-logo"
                         src="/rest/crm/insuranceCompany/{{childInsuranceCompany.id}}/image" alt="Zdjęcie" height="30"/>
                    <span [class.insurance-company-name]="childInsuranceCompany.imageLocation">{{childInsuranceCompany.name}}</span>
                  </div>
                </mat-list-option>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button (click)="save()" [class.spinner]="processingRequest" [disabled]="processingRequest || !contractInsuranceCompaniesForm.valid"
              mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Wygeneruj</span></button>
      <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
    </div>
  </div>
</mat-selection-list>
